import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Slider } from "@/components/ui/slider";
import { RefreshCw, Copy, Check, KeyRound } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function PasswordGeneratorModal({ open, onOpenChange }) {
  const [length, setLength] = useState(16);
  const [password, setPassword] = useState("");
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const generate = async (len = length) => {
    setLoading(true);
    try {
      const { data } = await api.get(`/utils/generate-password?length=${len}`);
      setPassword(data.password);
      setCopied(false);
    } catch {
      toast.error("Gagal generate password");
    } finally {
      setLoading(false);
    }
  };

  const copy = async () => {
    if (!password) return;
    await navigator.clipboard.writeText(password);
    setCopied(true);
    toast.success("Password disalin ke clipboard");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass-strong border-cyan-500/20 text-white max-w-md" data-testid="password-gen-modal">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2 text-xl">
            <KeyRound className="text-cyan-400" size={22} /> Pterodactyl Password Generator
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-400 -mt-2">Buat password kuat untuk login ke Pterodactyl Panel.</p>

        <div className="mt-2 p-4 rounded-xl bg-slate-950/60 border border-cyan-500/20 font-mono text-lg break-all min-h-[56px] flex items-center justify-between gap-3" data-testid="password-gen-result">
          <span className={password ? "text-cyan-300" : "text-slate-600"}>
            {password || "Klik Generate untuk membuat"}
          </span>
        </div>

        <div className="flex items-center justify-between text-sm text-slate-300">
          <span>Panjang: <span className="font-mono text-cyan-400">{length}</span></span>
        </div>
        <Slider value={[length]} min={8} max={48} step={1}
          onValueChange={(v) => setLength(v[0])} data-testid="password-gen-length-slider" />

        <div className="flex gap-3 mt-3">
          <Button onClick={() => generate()} disabled={loading}
            className="btn-cyan flex-1 text-white border-0" data-testid="password-gen-generate-btn">
            <RefreshCw size={16} className={`mr-2 ${loading ? "animate-spin" : ""}`} /> Generate
          </Button>
          <Button onClick={copy} disabled={!password} variant="outline"
            className="flex-1 border-cyan-500/30 bg-slate-900/60 text-cyan-300 hover:bg-cyan-600 hover:text-white"
            data-testid="password-gen-copy-btn">
            {copied ? <Check size={16} className="mr-2" /> : <Copy size={16} className="mr-2" />}
            {copied ? "Tersalin" : "Copy & Save"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
